import { Injectable } from '@angular/core';
import { FormControl, Validator, FormGroup, AbstractControl } from '@angular/forms';

@Injectable()
export class CompareValueValidator implements Validator {
    validator: Function;

    constructor() {
        this.validator = CompareValueValidator.compareValueValidatorFactory('');
    }

    validate(c: FormControl) {
        return this.validator(c);
    }

    static compareValueValidatorFactory(otherControl: string, notValue?: boolean) {
        return (c: AbstractControl) => {
        if (!c.parent || !(c.parent as FormGroup).controls) {
            return null;
        }

        const exactMatch = notValue ?
            (c.parent as FormGroup).controls[otherControl].value !== c.value :
            (c.parent as FormGroup).controls[otherControl].value === c.value;
        return exactMatch ? null : { mismatchedPassword: true };
        }
    }


}
